import { ApiKeyStatusEnum } from '@monetize/types/app';

export const API_KEY_STATUS_DISPLAY: {
  [key in ApiKeyStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  REVOKED: 'Revoked',
};
